// Mobile drawer
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-drawer-toggle]');
  if (t) {
    const drawer = document.querySelector('.mobile-drawer');
    if (drawer) drawer.classList.toggle('is-open');
  }
  const c = e.target.closest('[data-drawer-close]');
  if (c) document.querySelector('.mobile-drawer')?.classList.remove('is-open');

  // Accordion
  const a = e.target.closest('.accordion__btn');
  if (a) a.closest('.accordion__item').classList.toggle('is-open');
});
